import { IThunderboltEntry } from '@wix/editor-elements-types';

const entry: IThunderboltEntry = {
  loadComponent: hostAPI => {
    hostAPI.registerComponent('StateBox', () => {
      return Promise.all([
        import('./viewer/StateBox' /* webpackChunkName: "StateBox" */),
        import(
          './viewer/StateBox.controller' /* webpackChunkName: "StateBox" */
        ),
      ]).then(([componentModule, controllerModule]) => {
        return {
          component: componentModule.default,
          controller: controllerModule.default,
        };
      });
    });
  },
};

export default entry;
